import React, { Component } from 'react';
import PropTypes from 'prop-types';

import LogoWhite from '../../../assets/adventures/logo-white.png';
import LogoBlack from '../../../assets/adventures/logoblack.png';
import './Header.scss';

class Header extends Component {
  render() {
    let { data } = this.props;
    return (
      <div className='header flex justify-content'>
        <img
          src={data[0].great_guides[0].header.logo === 'white' ? LogoWhite : LogoBlack}
          alt='Logo'
        />
      </div>
    );
  }
}

Header.propTypes = {
  data: PropTypes.array,
};

export default Header;
